import React, { useEffect } from "react";
import Footer from "../Fotter";
import { CustomeStyle } from "../Css/CustomeStyle";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const OrderPlace = () => {
  const navigate = useNavigate();
  const CheckoutData = useSelector((state) => state.checkout?.CheckoutData);

  useEffect(() => {
    if (!CheckoutData || Object.keys(CheckoutData).length === 0) {
      navigate("/");
    }
  }, [CheckoutData, navigate]);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handleBackNavigation = () => {
      navigate("/");
    };
    window.addEventListener("popstate", handleBackNavigation);
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  }, [navigate]);

  const _handleClick = () => {
    navigate("/");
  };

  const renderOrderDate = () => {
    const orderDate = CheckoutData.order?.orderDate;
    const validDate = new Date(orderDate);
    if (isNaN(validDate.getTime())) {
      return "Invalid Date";
    }
    return validDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16647750621');
      `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16647750621/zBwdCKHYjcEaEN2HooI-",
        value: CheckoutData?.order?.totalPrice?.toFixed(2),
        currency: "INR",
        transaction_id: "",
      });
    }
  }, []);

  return (
    <div className="mt-[5%]">
      <div className="bg-white  rounded-lg p-6 max-w-4xl mx-auto border">
        <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
          Order Placed Successfully
        </h1>
        <section className="mb-8 p-4 bg-white  rounded-lg border border-gray-200">
          <h2 className="text-2xl font-bold mb-4 text-gray-900 lg:text-3xl md:text-2xl">
            Delivery Address
          </h2>
          <div className="text-lg text-gray-800 space-y-4">
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Order Id :</span>
              <p className="flex-1">{CheckoutData.order?.orderId}</p>
            </div>
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Name:</span>
              <p className="flex-1">
                {CheckoutData.order?.billingAddress?.firstName}{" "}
                {CheckoutData.order?.billingAddress?.lastName}
              </p>
            </div>
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Phone:</span>
              <p className="flex-1">
                {CheckoutData.order?.billingAddress?.phone}
              </p>
            </div>
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Address:</span>
              <p className="flex-1">
                {CheckoutData.order?.billingAddress?.streetAddress},{" "}
                {CheckoutData.order?.billingAddress?.city},{" "}
                {CheckoutData.order?.billingAddress?.state} ,
                {CheckoutData.order?.billingAddress?.pinCode}
              </p>
            </div>
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Country:</span>
              <p className="flex-1">India</p>
            </div>
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Email:</span>
              <p className="flex-1">
                {CheckoutData.order?.billingAddress.email}
              </p>
            </div>
            <div className="flex sm:flex-row items-start sm:items-center gap-2">
              <span className="font-semibold sm:w-24">Order Date:</span>
              <p className="flex-1">{renderOrderDate()}</p>{" "}
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className={CustomeStyle.headerText}>Order Summary</h2>
          <ul className="space-y-4">
            {CheckoutData.order?.items.map((item) => (
              <li
                key={item._id}
                className="flex flex-col sm:flex-row justify-between items-center bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-200"
              >
                <div className="flex items-center space-x-6">
                  <img
                    src={item?.productImage}
                    alt={item.name}
                    className="w-24 h-24 object-cover rounded-md shadow-sm"
                  />
                  <div className="flex flex-col">
                    <span className={CustomeStyle.textBlack}>
                      {item?.productId?.title}
                    </span>
                    <div className="flex sm:flex-row items-start  sm:items-center ">
                      <span className="text-black  text-xss sm:text-sm md:text-base  font-bold me-2">
                        Quantity :
                      </span>
                      <span className={CustomeStyle.text}>
                        {item?.quantity}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-lg font-semibold text-black">
                    ₹{item?.total}
                  </span>
                  <span className="text-sm line-through text-gray-500">
                    ₹{item?.price}
                  </span>
                </div>
              </li>
            ))}
          </ul>
          <div className="space-y-4 mt-6">
            <div className="flex justify-between text-lg">
              <span>Shipping Charges</span>
              <span className="text-black font-semibold">
                ₹ {CheckoutData?.order?.shippingCost}
              </span>
            </div>
            <div className="flex justify-between text-lg">
              <span>Subtotal</span>
              <span>₹{CheckoutData.order?.totalPrice?.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-lg">
              <span>Taxes (5%)</span>
              <span>0</span>
            </div>
            <div className="flex justify-between text-lg font-semibold">
              <span>Total</span>
              <span>₹{CheckoutData.order?.totalPrice?.toFixed(2)}</span>
            </div>
          </div>
        </section>
        <button
          onClick={() => _handleClick()}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-300 flex justify-center items-center mx-auto mt-10"
        >
          Return to Shop
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default OrderPlace;
